.container {
  display: flex;
  align-items: center;
  height: 29px;
  background-color: white;
}

.input {
  display: none;
}

.label {
  cursor: pointer;
  padding: 5px 6px;
  display: flex;
  margin-right: auto;
  width: 100%;
}

.extension {
  border-left: 1px solid var(--field-border);
  background-color: var(--main-background);
  padding: 5px 6px;
}

.extension .spacer {
  min-width: 15px;
}
